import { NgModule } from '@angular/core';
import { ListFilterPipe } from './pipe/list-filter.pipe';
import { OrdinalPipe } from './pipe/ordinal.pipe';
import { OrderByPositionPipe } from './pipe/order-by-position.pipe';

@NgModule({
  imports: [],
  declarations: [
    ListFilterPipe,
    OrdinalPipe,
    OrderByPositionPipe
  ],
  exports: [
    ListFilterPipe,
    OrdinalPipe,
    OrderByPositionPipe
  ],
})

export class PipeModule {

  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
} 